import script from "./AreaFilterDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaFilterDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AreaFilterDrawer.vue?vue&type=style&index=0&id=09747728&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09747728"]])

export default __exports__